module.exports = __webpack_public_path__ + "static/media/businessman.8e9bccfa.svg";